export const MINUTE_MS = 60_000;
export const DAY_MS = 24 * 60 * MINUTE_MS;
export const IST_OFFSET_MS = 330 * MINUTE_MS;

const positiveModulo = (value: number, modulus: number): number => ((value % modulus) + modulus) % modulus;

export const istMinuteOfDay = (instant: Date): number =>
  Math.floor(positiveModulo(instant.getTime() + IST_OFFSET_MS, DAY_MS) / MINUTE_MS);
